import React from 'react';
import styled from 'styled-components';

import { MANAGER_STATUSES as STATUSES } from '../../../../constants';

interface IManagerStatus {
  className?: string;
  status: (typeof STATUSES)[keyof typeof STATUSES];
}

const ManagerStatus = React.memo(
  ({ status, className = '' }: IManagerStatus) => {
    if (!status) {
      return null;
    }

    return <StyledManagerStatus className={className} status={status} />;
  }
);

ManagerStatus.displayName = 'ManagerStatus';

const StyledManagerStatus = styled.div<{
  status: (typeof STATUSES)[keyof typeof STATUSES];
}>`
  border-radius: 50%;
  height: 10px;
  width: 10px;

  ${({ status }) =>
    status === STATUSES.ONLINE &&
    `
    background-image: linear-gradient(to top, #f7aa1b, #faed61);
  `}

  ${({ status }) =>
    (status === STATUSES.IN_SERVICE || status === STATUSES.READY) &&
    `
    background-image: linear-gradient(to top, #00b0b6, #00e04b);
  `}
  
  ${({ status }) =>
    status === STATUSES.DND &&
    `
    background-image: linear-gradient(to top, #e5200e, #ff860c);
  `}
  
  ${({ status }) =>
    (status === STATUSES.AFTER_SERVICE || status === STATUSES.OFFLINE) &&
    `
    background-color: #c2c5cc;
  `}
`;

export default ManagerStatus;
